"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var Activities = function (_BaseApi) {
  (0, _inherits2["default"])(Activities, _BaseApi);

  function Activities() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Activities);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Activities)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getActivities", function (_ref) {
      var userId = _ref.userId,
          clientId = _ref.clientId,
          skip = _ref.skip,
          limit = _ref.limit,
          startAt = _ref.startAt,
          endAt = _ref.endAt,
          search = _ref.search;
      return _this.api.get("users/".concat(userId, "/activities"), {
        params: {
          clientId: clientId,
          skip: skip,
          limit: limit,
          startAt: startAt,
          endAt: endAt,
          search: search
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "replay", function (_ref2) {
      var query = _ref2.query;
      return _this.api.post('activities/replay-flow', {
        data: {
          query: query
        },
        params: {
          clientId: query.clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "replayActivity", function (_ref3) {
      var activityId = _ref3.activityId,
          clientId = _ref3.clientId;
      var query = {
        _id: activityId,
        clientId: clientId
      };
      return _this.replay({
        query: query
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createActivity", function (_ref4) {
      var activity = _ref4.activity,
          userId = _ref4.userId,
          clientId = _ref4.clientId;
      return _this.api.post('activities', {
        data: {
          activity: activity
        },
        params: {
          userId: userId,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editActivity", function (_ref5) {
      var activity = _ref5.activity,
          userId = _ref5.userId,
          clientId = _ref5.clientId;
      return _this.api.put("users/".concat(userId, "/activities/").concat(activity.id), {
        data: {
          activity: activity
        },
        params: {
          userId: userId,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteActivity", function (_ref6) {
      var activityId = _ref6.activityId,
          userId = _ref6.userId,
          clientId = _ref6.clientId;
      return _this.api["delete"]("users/".concat(userId, "/activities/").concat(activityId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uploadActivity", function (data) {
      return _this.api.post("apps/import/push", {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGradientsActivities", (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch('https://assets-product.sportheroesgroup.com/oly/static/json/activities-gradient.json');

            case 2:
              response = _context.sent;
              _context.next = 5;
              return response.json();

            case 5:
              return _context.abrupt("return", _context.sent);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createPushProviderActivity", function (_ref8) {
      var app = _ref8.app,
          activity = _ref8.activity,
          userId = _ref8.userId,
          clientId = _ref8.clientId;
      return _this.api.post("apps/".concat(app, "/push"), {
        data: {
          activity: activity
        },
        params: {
          userId: userId,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createPushProviderActivities", function (_ref9) {
      var app = _ref9.app,
          activities = _ref9.activities,
          userId = _ref9.userId,
          clientId = _ref9.clientId;
      return _this.api.post("apps/".concat(app, "/push"), {
        data: {
          activities: activities
        },
        params: {
          userId: userId,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "canCreateActivity", function (_ref10) {
      var userId = _ref10.userId;
      return _this.api.get("/users/".concat(userId, "/activities/manual"), {});
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOneActivity", function (_ref11) {
      var activityId = _ref11.activityId,
          clientId = _ref11.clientId,
          userId = _ref11.userId;
      return _this.api.get("activities/".concat(activityId), {
        params: {
          clientId: clientId,
          userId: userId
        }
      });
    });
    return _this;
  }

  return Activities;
}(_createApi.BaseApi);

var _default = Activities;
exports["default"] = _default;
//# sourceMappingURL=activities.js.map